import { SET_PLATFORM } from 'actions';
import { Platform } from 'typings';

export function setPlatform(platform: Platform) {
  return { platform, type: SET_PLATFORM };
}
